import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';
import CustomSelect from 'components/atoms/dropdowns/custom-select';
import Loader from 'components/atoms/loaders/loader';

function getOption(value, label) {
    return {value, label};
}

function getLabel(slate) {
    const label = [];

    if (slate.title) {
        label.push(`${slate.title}:`);
    }
    if (slate.start_date) {
        label.push(`from ${slate.start_date}`);
    }
    if (slate.end_date) {
        label.push(`to ${slate.end_date}`);
    }

    return label.join(' ');
}

class SlateSwitch extends Component {
    componentDidMount() {
        this.loadSlates();
    }

    componentDidUpdate(props) {
        const {sportConfig} = this.props;
        if (
            sportConfig.hasSport() &&
            sportConfig.hasSite() &&
            (!sportConfig.isSiteEqual(props.sportConfig.getSite()) ||
                !sportConfig.isSportEqual(props.sportConfig.getSport()))
        ) {
            this.loadSlates();
        }
    }

    onChange(selected) {
        const value = selected !== undefined ? String(selected.value) : '';
        this.props.dispatch(Action.set('SlateFilter', value));
    }

    renderOption(item) {
        return item.label;
    }

    render() {
        const {slates, sportConfig} = this.props;

        if (!sportConfig.hasSite() || !sportConfig.hasSport()) {
            return null;
        }

        if (slates.isLoading()) {
            return <Loader key="loading" />;
        }

        let content = (
            <div className="not-found-text" key="games-not-found">
                Slates were not found.
            </div>
        );
        if (slates.isReady()) {
            const sortedSlates = slates.getAsSortedArr('start_date', 'desc');
            const options = sortedSlates.map((slate) => getOption(slate.id, getLabel(slate)));
            const slateId = sportConfig.getSlateId();
            const value = slateId ? getOption(slateId, getLabel(slates.getById(slateId))) : '';

            content = (
                <CustomSelect
                    defaultValue={value}
                    options={options}
                    value={value}
                    renderOption={::this.renderOption}
                    onChange={::this.onChange}
                />
            );
        }

        return (
            <div className="slates-cell" data-testid="slate-dropdown">
                <label className="label-alt">Slates</label>
                {content}
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        playersData: {slates},
    } = state;
    return {
        slates,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(SlateSwitch);
